<template>
  <div router class="MobileMenu">
    <div class="MobileMenu-routes">
      <router-link :to="{ name: 'dashboard' }" class="Route">
        <ubi-icon class="Route-icon" name="dashboard" />
        <span class="Route-title">{{ $t("layouts.dashboard") }}</span>
      </router-link>
      <router-link :to="{ name: 'posts', query: { reset: 1} }" class="Route" v-if="(getProduits != null && getProduits.hasDiffusion)">
        <ubi-icon class="Route-icon" name="announcement" />
        <span class="Route-title">{{ $t("layouts.ads") }}</span>
      </router-link>
      <router-link class="Route Route--myPortals" :to="{ name: 'portals' }">
        <ubi-icon class="Route-icon" name="direction" />
        <span class="Route-title">{{ $t("layouts.diffusion") }}</span>
      </router-link>
      <router-link
        class="Route Route--contactManager"
        :to="{ name: 'contacts' }"
      >
        <ubi-icon class="Route-icon" name="agenda" />
        <span class="Route-title">{{ $t("layouts.contactManager") }}</span>
      </router-link>
      <router-link
        class="Route Route--localPresence"
        id="idBoutonSFC"
        :to="{ name: 'Presence' }"
        v-if="!hasLocalSeo"
      >
        <ubi-icon class="Route-icon" name="location-pin" />
        <span class="Route-title">{{ $t("layouts.localPresence") }}</span><span class="Route-title"> - {{ $t("layouts.sfc") }}</span>
      </router-link>
      <a
        class="Route Route--localPresence"
        id="idBoutonSFC"
        :href="urlSfc"
        v-if="hasLocalSeo"
      >
        <ubi-icon class="Route-icon" name="location-pin" />
        <span class="Route-title text-center">{{ $t("layouts.localPresence") }}  <br/> {{ $t("layouts.sfc") }}</span>
      </a>
    </div>
<!--    <div>{{this.userSite}}</div>-->
    <div class="MobileMenu-marketing">
      <marketing-button v-if="isFr"/>
    </div>
  </div>
</template>

<script>
import MarketingButton from './menu/MarketingButton'
import i18next from 'i18next'
import { getUrlSFC } from '@/services/users'
import { mapGetters } from 'vuex'

export default {
  name: 'MobileMenu',
  components: {
    MarketingButton
  },
  methods: {
    async connexionSFC () {
      const urlSfc = await getUrlSFC(this.$store.getters.getUser)
      window.open(urlSfc, '_blank')
    }
  },
  computed: {
	  ...mapGetters('productLine', ['hasLocalSeo']),
    ...mapGetters(['getProduits']),
	  sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    universClient () {
      return this.sitimmoUser.univers
    },
    isFr () {
      return i18next.language === 'fr'
    }
  }
}
</script>

<style lang="scss">
@import "@/theme/_bootstrap.scss";

.MobileMenu {
  @extend .pb-4;

  &-routes {
    margin: map-get($spacers, 3) - map-get($spacers, 2);
    display: flex;
    flex-wrap: wrap;
    .Route {
      @extend .rounded, .m-2, .py-3, .px-2, .text-decoration-none;

      align-items: center;
      background: $gray-200;
      border: 1px solid $gray-300;
      color: $gray-600;
      display: flex;
      flex-direction: column;
      flex: 1;
      justify-content: center;
      min-width: 40%;

      &-title {
        @extend .font-secondary;
        font-size: $font-size-base-alt;
      }
      &-icon {
        font-size: $font-size-base * 2;
      }

      &--empty {
        opacity: 0;
        pointer-events: none;
      }
      &--myPortals {
        border-color: theme-color("primary");
        background-color: rgba(theme-color("primary"), 0.1);
        .Route-icon {
          @extend .text-primary;
        }
      }
      &--contactManager {
        border-color: theme-color("danger");
        background-color: rgba(theme-color("danger"), 0.1);
        .Route-icon {
          @extend .text-danger;
        }
      }
      &--localPresence {
        border-color: theme-color("warning");
        background-color: rgba(theme-color("warning"), 0.1);
        .Route-icon {
          @extend .text-warning;
        }
      }
    }
  }

  &-marketing {
    text-align: center;
  }
}
</style>
